import { useThemePreferences } from '@/hooks/useThemePreferences'

/**
 * Applies the current user's appearance for the current organization (light/dark
 * mode + sidebar theme) app-wide, and re-applies it on every org switch. Without
 * this the hook only ran on settings pages, so every org shared one look.
 */
export function ThemePreferencesSync() {
  useThemePreferences()
  return null
}
